import FrameComponent from './FrameComponent';

export default FrameComponent;
